// This file contains slide decks associated with Software Engineering (SE). 

import { xyz_n_2of4_PAaA, xyz_n_2of4, xyz_n_3of4_PAaA, xyz_n_3of4 } from './SL00000Sprint00TTR'
import { xyz_n_4of4 } from './SL44000Sprint01TTR'

import { agendaSlide, basicSlide, bulletListSlide, orderedListSlide, tPrework, tRecap, tPreworkWithLogo, basicSlideWithLogo } from './SLSprint00'
import { makeSlideDeck, tReviewDemoSchedule } from './SL00000Sprint00'
import { breakoutStandard, submissionPercentage } from './SLSprint00'

import { list44000Sprint02 } from '../ActivityLists/AL44000Sprint02'
import { list44000Sprint03 } from '../ActivityLists/AL44000Sprint03'

// Software Engineering (SE) sprint 2 global values.
const sprint = 3
const activityList = () => { return list44000Sprint03(sprint) }
const activityListPrevious = () => { return list44000Sprint02(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Shared slides across multiple sessions.
export const xyz_3_1of4 = (pAaA, pAaANext, saals) => {
	const prework = () => { return tPreworkWithLogo('Prework For Today', pAaA.prework, saals.sprint-1, saals.activityListPrevious) }
	const announcements =  () => { return basicSlideWithLogo( 'Announcements', ['Let’s stay focused on sprint planning today']) }
	const agenda = () => { return agendaSlide(pAaA.agenda) }
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${saals.sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			`Similar in that we will have two weeks to complete all sprint ${sprint} assignments`,
			`Similar in that  we will work on Discussion Board ${sprint} as a scrum team in class on Thursday`,
			`Similar in that we will have sprint ${sprint-1} Demos and Retrospectives on Thursday`,
			'Similar in that we will meet in-person during our normal class times' ])
	}
	const activitiesReview = () => {
		return basicSlide('Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the activity list, syllabus, and assignments together.' ])
	}
	const planningBreakout = () => {
		return orderedListSlide('Sprint Planning Scrum Team Breakout', 'As a scrum team:', [
			`Review sprint ${saals.sprint} activity list & assignments in detail`,
				'Discuss and identify questions/concerns',
				'Scrum master report out by sharing scrum team’s top 2 or 3 questions/concerns',
				'How will you get your Scrum Team Discord server set up before class on Thursday?' ])
	}
	const qAndA = () => {
		return bulletListSlide('Q & A', 
			'Questions & Answers:', [
	 		'Why are we making these changes?',
			'Can we still use the room?',
			'How can we best stay connected as a class and as scrum teams?',
			'Might there be exceptions to the new schedule?',
			'How do we best get in touch with you if we have questions later?',
			'What about Puppy Day?' ])
	}
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda) }

	return makeSlideDeck([ prework, announcements, agenda, sprintPlanningExpectations, activitiesReview, planningBreakout, tReviewDemoSchedule, qAndA, preworkNext, recap ])
}
// End shared slides across multiple class sections.

// Session 1 of 4: Tuesday
export const se_3_1of4_PAaA = { 
	'prework':[ 
		'Everything is due Sunday!', '',
		`Be prepared for Sprint ${sprint} Planning` ],
	'announcements':[ 
		`Sprint ${sprint} starts now.` ],
	'agenda':[ 
		`Sprint ${sprint} Planning`,
		`Sprint ${sprint} Planning Breakout`,
		'Review Demos and Demo Schedule',
		'Upcoming Changes to the Course Structure',
		'Prework for Next Class' ]
}
const se_3_1of4 = () => { return xyz_3_1of4(se_3_1of4_PAaA, se_3_2of4_PAaA, sprintAndActivityLists ) } 

// Session 2 of 4: Thursday
const completeThrough = 6
const se_3_2of4_PAaA = xyz_n_2of4_PAaA(completeThrough, sprint)

const se_3_2of4 = () => {
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:19, submitted:18 },
			{ name: 'Quiz', due:19, submitted:19 },
			{ name: 'Lab', due:19, submitted:19 },
			{ name: 'Reflection', due:19, submitted:19 }])
	}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			'Thank you for your support when we had to go remote asynchronous!',
			`Excellent submission percentage in sprint ${sprint-1}... very strange to have one Discussion missing this sprint also`,
			'I read all of your Reflections but have not graded/posted sprint 3 Labs or Reflections', 
			'Lots of nice comments about scrum teammates',
			'Supper big Thank You for the music recommendations :-)',
			`If you are not where you want to be in the class after sprint ${sprint-1}, let’s set up a time to talk.`,
			`If you are not where you want to be in the class after sprint ${sprint}, you should consider dropping` ])
	}
	return xyz_n_2of4(se_3_2of4_PAaA, se_3_3of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective) 
}

// Session 3 of 4: Tuesday
const breakoutRequirementsName = 'Requirements'
const breakoutRequirements = () => {
	return breakoutStandard( 
		`${breakoutRequirementsName} Breakout`, 
		`In this breakout session on “${breakoutRequirementsName}” your team will discuss:`, [
		'Are requirements actually requirements?',
		'Requirements, User Stories, Product Backlog, Sprint Backlog',
		'Done',
		'Behavior-Driven Design and Gemba (or Genba)',
		'Points, velocity, SMART, and MVP',
		'Story Points, Use Case Points, Function Points, and measuring productivity across teams',
		'User Experience / User Interface Design, Interface Sketches, and Storyboards',
		'Requirements Gathering Waterfall (Requirements?) vs. Iterative (Use Cases) vs. Agile (Stories)' ])
}

const se_3_3of4_PAaA = xyz_n_3of4_PAaA(11, sprint, breakoutRequirementsName)
const se_3_3of4 = () => { return xyz_n_3of4(se_3_3of4_PAaA, se_3_4of4_PAaA, sprintAndActivityLists, breakoutRequirements) } 

// Session 4 of 4: Thursday
const se_3_4of4_PAaA = {
	'prework':[
		'Complete through activity 13 prior to next class', 
		'Be prepared for Lab' ],
	'announcements':[
		`All sprint ${sprint} activities and assignments due Sunday!`,
		`Required in person attendance for Sprint ${sprint} Planning on Tuesday` ],
	'agenda':[
		`Final sprint ${sprint} activity list and assignment Q&A`,
		'Prework for Next Class', 
		'Lab']
}
const se_3_4of4 = () => { return xyz_n_4of4(sprint, activityList, se_3_4of4_PAaA, se_4_1of4_PAaA.prework ) }

// Sprint 4
// Session 1 of 4: Tuesday
export const se_4_1of4_PAaA = { 
	'prework':[ 
		'Everything is due Sunday!', '',
		`Be prepared for Sprint ${sprint} Planning`,
		`Required in person attendance for Sprint ${sprint} Planning on Tuesday` ],
	'announcements':[ 
		`Sprint ${sprint} starts now.` ],
	'agenda':[ 
		`Sprint ${sprint} Planning`,
		`Sprint ${sprint} Planning Breakout`,
		'Review Demos and Demo Schedule',
		'Review Course Structure',
		'Prework for Next Class' ]
}

export const se_3_slidedeckTTR = [ se_3_1of4, se_3_2of4, se_3_3of4, se_3_4of4 ] 